import Highcharts from 'highcharts';
import {numberRange} from './utilities';

export const figure32 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    exporting: {
        enabled: false
    },

    xAxis: [{
        categories: numberRange(2000, 2018),
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#4472c4'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}0 %',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 18.8,
        min: 16.8,
        tickInterval: 0.2,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ {
        name: 'Estrés hídrico mundial',
        id: "prev",
        type: 'line',
        color: '#5b9bd5',
        zoneAxis: 'x',
        dataLabels: {
            enabled: false,
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },
        data: [17.42,	17.55,	17.76,	17.92,	18.08,	18.21,	18.40,	18.66,	18.40,	18.42,	17.87,	17.87,	17.98,	18.01,	18.13,	18.18,	18.30,	18.43,	18.41],
    }],


};
